export default "/static/43a494cefd1657c7.png"